<form [formGroup]="form">
  <ng-container *ngIf="counterPrefix.show" [ngTemplateOutlet]="counterPrefixTpl"></ng-container>
  <ng-container *ngIf="!counterPrefix.show" [ngTemplateOutlet]="counterDefaultTpl"></ng-container>
</form>

<ng-template #counterPrefixTpl>
  <div class="counter d-flex flex-wrap mw-100">
    <div class="input-group input-group-solid">
      <input
        type="text"
        class="form-control form-control-solid border-end-0"
        placeholder="0"
        minlength="1"
        [formControl]="counter"
        (keyup)="handleChangeOnTyping($event)"
      />
      <span class="input-group-text px-6 text-capitalize">{{counterPrefix.label}}</span>
    </div>
  </div>
</ng-template>

<ng-template #counterDefaultTpl>
  <div class="counter d-flex align-items-center flex-wrap m-auto mw-200px" [class.justify-content-center]="!counterButton">
    <button
      *ngIf="counterButton"
      type="button"
      class="me-4 px-0 py-0 btn btn-bg-none btn-counter btn-counter--decrease"
      (click)="decrement()"
      [disabled]="!counterValue || counterValue < 1"
    >
      <span class="svg-icon svg-icon2 btn-plus-minus" [inlineSVG]="STRING_CONSTANTS.ICON.IC_MINUS"></span>
    </button>

    <div class="input-group col mx-4 mw-100px">
      <fieldset>
        <input
          type="text"
          class="form-control form-control-solid border-gray-300 text-center"
          placeholder="0"
          minlength="1"
          [formControl]="counter"
          (keyup)="handleChangeOnTyping($event)"
        />
      </fieldset>
    </div>

    <button
      *ngIf="counterButton"
      type="button"
      class="me-4 px-0 py-0 btn btn-bg-none btn-counter btn-counter--increase"
      (click)="increment()"
      [disabled]="buttonAddShouldDisabled()"
    >
      <span class="svg-icon svg-icon2 btn-plus-minus" [inlineSVG]="STRING_CONSTANTS.ICON.IC_PLUS_BLACK"></span>
    </button>
  </div>
</ng-template>
